<template>
  <div
    v-if="isLoading(state)"
    :class="daytimeTheme ? 'load-state-loading daytime' : 'load-state-loading'"
  >
    <!-- 日中助産師相談の場合は、LINE風UIの背景色と違和感のないスピナー表示を出し分ける -->
    <div
      v-if="daytimeTheme"
      class="daytime-spinner"
      role="status"
      aria-live="polite"
      aria-label="読み込み中"
    />
    <v-img
      v-else
      src="/loading.gif"
    />
  </div>
  <div
    v-else-if="isError(state)"
    class="col-md-12 text-center"
  >
    <p style="font-size: 14px; color:#D72E4B;">
      読み込みに失敗しました
    </p>
    <v-btn
      :id="reloadButtonId"
      color="pink-lighten-1"
      class="mt-auto"
      flat
      @click="reload"
    >
      再読み込み
    </v-btn>
  </div>
</template>

<script>
import loadStateMixin from "../../mixins/load_state.js";

export default {
  name: "LoadStateDisplay",
  mixins: [loadStateMixin],
  props: {
    state: {
      type: String,
      required: true
    },
    reloadButtonId: {
      type: String,
      required: true
    },
    daytimeTheme: {
      type: Boolean,
      default: false
    }
  },
  emits: ["reload"],
  methods: {
    reload() {
      this.$emit("reload");
    }
  }
};
</script>

<style scoped>
.load-state-loading.daytime {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 128px;
  background: transparent;
}

.daytime-spinner {
  width: 128px;
  height: 128px;
  border-radius: 50%;
  border: 3px solid rgba(255, 255, 255, 0.45);
  border-top-color: rgba(255, 255, 255, 0.95);
  animation: daytime-spin 0.8s linear infinite;
}

@keyframes daytime-spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
